<script src="../../lineup/lineup-premiere/lineup-premiere.component.ts"></script>
<div class="divLineup" style="background-color: white; ">

    <div fxLayout="row" fxFlex="37">
        <span>
            <img class="image" src="{{premiere.mobilethumbimage}}" />
        </span>

    </div>

    <div fxFlex="63" fxLayout="row wrap">

        <h3 class="spotlightsDate">
            {{premiere.cinejoySpotlightsSchedule[0]?.scheduleTimeText | date:'EEE, MMM d, y, h:mm:ss a'}}
            {{timezone}}<br>

        </h3>

        <h3 fxFlex.lt-md="100" fxFlex="100" class="spotLightsTitle">{{premiere.name}}</h3>
        <a class="spotLightsTitle" style="font-size: 12px;margin-bottom: 5px;" [href]="groupshareUrl" target="_blank">Experience Spotlight with Group</a>
        <div fxLayoutAlign="start" fxLayout="row" class="spotlight_button" fxLayoutGap="6px">

            <button id="btn1" *ngIf="!isBuyButtonActive" (click)="open(premiere.eventId, premiere, 'Buy')">{{bulkPurchaseEnabled?'Buy One tix':'Buy'}}</button>
          <button id="btn5" (click)="initiateBulkPurchase(premiere.eventId)" *ngIf="bulkPurchaseEnabled && !isBuyButtonActive">Buy Bulk Tix</button>
            <button id="btn2" (click)="redirect()" [disabled]="joinButtonDisabled">Join</button>
            <button id="btn3" (click)="gotoMoreInfo(premiere.eventId,premierename)">More Info</button>
            <button id="btn4" (click)="openDialog(premiere)" style="margin-top: 5px;" *ngIf="isBuyButtonActive && createGroup">
                <ng-container *ngIf="!exsistingGroup">Create Group</ng-container>
                <ng-container *ngIf="exsistingGroup">Manage Group</ng-container>
             </button>
        </div>


    </div>

</div>
